import * as yup from 'yup';

export const getForgotPasswordForm = yup.object().shape({
  email: yup.string().email('Adresse email est invalide').required('Une adresse email est requise'),
});
